import { render, staticRenderFns } from "./GDPR.vue?vue&type=template&id=e225e35c&scoped=true"
import script from "./GDPR.vue?vue&type=script&lang=js"
export * from "./GDPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e225e35c",
  null
  
)

export default component.exports